module.exports = __webpack_public_path__ + "img/train.168aafd7.svg";